import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export function useActiveCampaignName(): string | null {
  const { activeWorkspaceId } = useAuth();
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase.rpc("list_my_knowledge_assistants");
      if (cancelled || !data) return;
      const list = data as Array<{
        id: string;
        name: string;
        scope: string;
        organization_id: string | null;
      }>;
      const match =
        list.find(
          (a) => a.scope === "campaign" && a.organization_id === activeWorkspaceId,
        ) ?? list.find((a) => a.scope === "campaign");
      setName(match?.name ?? null);
    })();
    return () => {
      cancelled = true;
    };
  }, [activeWorkspaceId]);

  return name;
}
